import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PRODUCT_URL } from '@insite-store360/shared';
import { catchError, Observable } from 'rxjs';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({
  providedIn: 'root',
})
export class RetailerServiceService {
  // private readonly PRODUCT_SEVICE_URL = `${environment.apiUrl}`;

  private readonly PRODUCT_SEVICE_URL = `${PRODUCT_URL}`;
  constructor(
    private http: HttpClient,
    private errorHandler: ErrorHandlerService
  ) { }




  //// SAP Sync services
  public getSapMissingCountByCountry(regionIds?: number[]): Observable<any> {
    let queryParams = new HttpParams();
    if (regionIds && regionIds.length > 0) {
      queryParams = queryParams.set('regionId', regionIds.join(','));
    }
    return this.http
      .get<any>(`${this.PRODUCT_SEVICE_URL}/retailer-products/missing-count-by-country`, { params: queryParams })
      .pipe(catchError(this.errorHandler.handleError));
  }

  public getSapUnsyncedProducts(pageIndex: number, pageSize: number, countryId?: number, categoryId?: number[], subCategoryId?: number[], brandId?: number[], duplicateOnly?: boolean, searchValue?: string): Observable<any> {



    let queryParams = new HttpParams();
    if (countryId) {
      queryParams = queryParams.set('countryId', countryId.toString());
    }
    if (pageIndex !== undefined && pageIndex !== null) {
      queryParams = queryParams.set('pageIndex', pageIndex.toString());
    }
    if (pageSize !== undefined && pageSize !== null) {
      queryParams = queryParams.set('pageSize', pageSize.toString());
    }

    if (categoryId && categoryId.length > 0) {
      queryParams = queryParams.set('categoryId', categoryId.toString());
    }


    if (subCategoryId && subCategoryId.length > 0) {
      queryParams = queryParams.set('subCategoryId', subCategoryId.toString());
    }


    if (brandId && brandId.length > 0) {
      queryParams = queryParams.set('brandId', brandId.toString());
    }

    if (duplicateOnly) {
      queryParams = queryParams.set('duplicateOnly', 'true');
    }

    if (searchValue) {
      queryParams = queryParams.set('searchValue', searchValue);
    }

    return this.http
      .get<any>(`${this.PRODUCT_SEVICE_URL}/retailer-products/unsynced-products`, { params: queryParams })
      .pipe(catchError(this.errorHandler.handleError));
  }


  public downloadTemplateSynRetailerProducts(countryId?: number, categoryId?: string[], subCategoryId?: string[], brandId?: string[]): Observable<Blob> {
    let queryParams = new HttpParams();

    if (countryId) {
      queryParams = queryParams.set('countryId', countryId);
    }
    if (categoryId && categoryId.length > 0) {
      queryParams = queryParams.set('categoryId', categoryId.toString());
    }


    if (subCategoryId && subCategoryId.length > 0) {
      queryParams = queryParams.set('subCategoryId', subCategoryId.toString());
    }


    if (brandId && brandId.length > 0) {
      queryParams = queryParams.set('brandId', brandId.toString());
    }

    return this.http
      .get<Blob>(`${this.PRODUCT_SEVICE_URL}/retailer-products/downloadExcelTemplate`, {
        params: queryParams,
        responseType: 'blob' as 'json'
      })
      .pipe(catchError(this.errorHandler.handleError));
  }
  public syncProductsFromSap(data: any): Observable<any> {
    return this.http
      .post<any>(`${this.PRODUCT_SEVICE_URL}/retailer-products/sync-products`, data)
      .pipe(catchError(this.errorHandler.handleError));
  }


  public syncProductsFromRetailerimports(data: any): Observable<any> {
    return this.http
      .post<any>(`${this.PRODUCT_SEVICE_URL}/retailer-products/sync-products-imports`, data)
      .pipe(catchError(this.errorHandler.handleError));
  }

  public validateSyncProductsFromRetailerimports(data: any): Observable<any> {
    return this.http
      .post<any>(`${this.PRODUCT_SEVICE_URL}/retailer-products/validate-sync-imports`, data)
      .pipe(catchError(this.errorHandler.handleError));
  }

  public getAllProductlineByCountry(countryId?: number): Observable<any> {

    let queryParams = new HttpParams();

    if (countryId) {
      queryParams = queryParams.set('countryId', countryId);
    }
    return this.http
      .get<any>(`${this.PRODUCT_SEVICE_URL}/retailer-products/product-line`, { params: queryParams })
      .pipe(catchError(this.errorHandler.handleError));
  }


  public getAllBrandsByCountry(countryId?: number): Observable<any> {

    let queryParams = new HttpParams();

    if (countryId) {
      queryParams = queryParams.set('countryId', countryId);
    }
    return this.http
      .get<any>(`${this.PRODUCT_SEVICE_URL}/retailer-products/brands`, { params: queryParams })
      .pipe(catchError(this.errorHandler.handleError));
  }

  //to fetch all fsbi
  public getFsBiAllByCountry(countryId?: number): Observable<any> {
    let queryParams = new HttpParams();

    if (countryId) {
      queryParams = queryParams.set('countryId', countryId);
    }
    return this.http.get(`${this.PRODUCT_SEVICE_URL}/retailer-products/fsbi`, { params: queryParams });
  }

  //to fetch all mdasda
  public getMdSdaAllByCountry(countryId?: number): Observable<any> {
    let queryParams = new HttpParams();

    if (countryId) {
      queryParams = queryParams.set('countryId', countryId);
    }
    return this.http.get(`${this.PRODUCT_SEVICE_URL}/retailer-products/mdasda`, { params: queryParams });
  }

  public getProductSegmentByCountryId(countryId?: number): Observable<any> {
    let queryParams = new HttpParams();

    if (countryId) {
      queryParams = queryParams.set('countryId', countryId);
    }
    return this.http
      .get<any>(`${this.PRODUCT_SEVICE_URL}/retailer-products/segments`, { params: queryParams })
      .pipe(catchError(this.errorHandler.handleError));
  }


  public getAllCategoriesByCountry(params: {
    countryId?: number
    productLineId?: number
  }): Observable<any> {
    let queryParams = new HttpParams();

    if (params.countryId) {
      queryParams = queryParams.set('countryId', params.countryId);
    }
    if (params.productLineId) {
      queryParams = queryParams.set('productLineId', params.productLineId);
    }
    return this.http
      .get<any>(`${this.PRODUCT_SEVICE_URL}/retailer-products/categories`, {
        params: queryParams,
      })
      .pipe(catchError(this.errorHandler.handleError));
  }


  public getAllSubCategoriesByCategory(
    countryId: number[],
    categoryId?: number
  ): Observable<any> {
    let queryParams = new HttpParams();
    if (countryId && countryId.length > 0) {
      queryParams = queryParams.set('countryId', countryId.join(','));
    }
    if (categoryId && categoryId !== 0) {
      queryParams = queryParams.set('categoryId', categoryId);
    }
    return this.http
      .get<any>(
        `${this.PRODUCT_SEVICE_URL}/retailer-products/sub-categories`,
        { params: queryParams }
      )
      .pipe(catchError(this.errorHandler.handleError));
  }


  public getAllSAPBrandsByCountry(countryId?: number): Observable<any> {

    let queryParams = new HttpParams();

    if (countryId) {
      queryParams = queryParams.set('countryId', countryId);
    }
    return this.http
      .get<any>(`${this.PRODUCT_SEVICE_URL}/retailer-products/retailer-brands`, { params: queryParams })
      .pipe(catchError(this.errorHandler.handleError));
  }

  public getAllSAPCategoriesByCountry(params: {
    countryId?: number
    productLineId?: number
  }): Observable<any> {
    let queryParams = new HttpParams();

    if (params.countryId) {
      queryParams = queryParams.set('countryId', params.countryId);
    }
    if (params.productLineId) {
      queryParams = queryParams.set('productLineId', params.productLineId);
    }
    return this.http
      .get<any>(`${this.PRODUCT_SEVICE_URL}/retailer-products/retailer-categories`, {
        params: queryParams,
      })
      .pipe(catchError(this.errorHandler.handleError));
  }


  public getAllSAPSubCategoriesByCategory(
    countryId: number[],
    categoryId?: number
  ): Observable<any> {
    let queryParams = new HttpParams();
    if (countryId && countryId.length > 0) {
      queryParams = queryParams.set('countryId', countryId.join(','));
    }
    if (categoryId && categoryId !== 0) {
      queryParams = queryParams.set('categoryId', categoryId);
    }
    return this.http
      .get<any>(
        `${this.PRODUCT_SEVICE_URL}/retailer-products/retailer-sub-categories`,
        { params: queryParams }
      )
      .pipe(catchError(this.errorHandler.handleError));
  }





}
